// Painel de filtros de Produtos: um cartão por assunto, cada um com as opções
// lado a lado e quantos produtos caem em cada uma.
import React from "react";
import { Camera, ClipboardList, EyeOff, FileText, Layers, PackageX, Receipt, Tag } from "lucide-react";

import CategoriaBusca from "./CategoriaBusca";
import { TODOS } from "./regras";

const ICONES = {
  tipo: Layers, estoque: PackageX, visivel: EyeOff, foto: Camera,
  descricao: FileText, ficha: ClipboardList, fiscal: Receipt,
};

function Cartao({ icone: Icone, titulo, ativo, children }) {
  return (
    <div className="min-w-0">
      <div className={`flex items-center gap-1 mb-1 text-[10px] font-semibold uppercase tracking-wide ${ativo ? "text-primary" : "text-muted-foreground"}`}>
        <Icone className="w-3 h-3" /> {titulo}
      </div>
      {children}
    </div>
  );
}

function Opcoes({ grupo, valor, aoMudar, conta }) {
  const lista = [{ valor: TODOS, rotulo: grupo.todos }, ...grupo.opcoes];
  return (
    <div className="flex rounded-md bg-muted/70 p-0.5 gap-0.5" role="radiogroup" aria-label={grupo.titulo}>
      {lista.map((o) => {
        const marcado = (valor || TODOS) === o.valor;
        return (
          <button key={o.valor} type="button" role="radio" aria-checked={marcado}
            data-e2e={`filtro-${grupo.chave}-${o.valor}`}
            onClick={() => aoMudar(grupo.chave, o.valor)}
            title={o.etiqueta || o.rotulo}
            className={`flex-auto min-w-0 h-7 px-1 rounded text-[11px] transition-all flex items-center justify-center gap-1 ${
              marcado ? "bg-primary text-primary-foreground font-semibold shadow-sm" : "text-muted-foreground hover:bg-background/70 hover:text-foreground"
            }`}>
            <span className="truncate">{o.rotulo}</span>
            {o.teste && <span className={`text-[10px] font-normal tabular-nums ${marcado ? "opacity-80" : "opacity-50"}`}>{conta(o.teste)}</span>}
          </button>
        );
      })}
    </div>
  );
}

export default function PainelFiltros({ produtos, categorias, grupos, filtros, aoMudar, children }) {
  const conta = (teste) => produtos.filter(teste).length;
  const contaCategoria = (nome) => produtos.filter((p) => p.category === nome).length;
  return (
    <div className="bg-muted/30 rounded-lg border px-3 py-2.5 space-y-2.5 animate-in slide-in-from-top-2 duration-200" data-e2e="painel-filtros-produtos">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-2.5">
        <Cartao icone={Tag} titulo="Categoria" ativo={filtros.categoria !== TODOS}>
          <CategoriaBusca categorias={categorias} valor={filtros.categoria} contagem={contaCategoria}
            aoMudar={(v) => aoMudar("categoria", v)} />
        </Cartao>
        {grupos.map((g) => (
          <Cartao key={g.chave} icone={ICONES[g.chave]} titulo={g.titulo} ativo={filtros[g.chave] !== TODOS}>
            <Opcoes grupo={g} valor={filtros[g.chave]} aoMudar={aoMudar} conta={conta} />
          </Cartao>
        ))}
      </div>
      {children}
    </div>
  );
}
